export const calculateColumnWidth = (width) => {
  const widths = {
    "1/1": '1320',
    "1/2": '670',
    "1/3": '450',
    "1/4": '340',
    "2/3": '880',
    "1/6": '240',
    "5/12": '550',
    "7/12": '770',
  }

  return widths[width]
}